<template>
    <div
        class="button-wrapper group whitespace-nowrap rounded-[8px] font-medium text-white shadow-sm hover:cursor-pointer"
    >
        <button class="button-cta flex h-12 w-full justify-center px-3.5">
            <slot></slot>
        </button>
    </div>
</template>

<script setup lang="ts"></script>

<style scoped>
.button-wrapper {
    display: flex;
    flex-direction: row;
    background: #26272b;
    position: relative;
    z-index: 1;
    overflow: hidden;
}

.button-wrapper::after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    transition: opacity 110ms cubic-bezier(0.455, 0.03, 0.515, 0.955);
    background: linear-gradient(
        143.16deg,
        #ff8d47 5.29%,
        #ff7447 18.74%,
        #ff4247 46.66%,
        #e92a5b 63.32%,
        #dd1c67 72.74%,
        #d31071 82.09%,
        #cf0283 96.39%
    );
    opacity: 0;
}

.button-cta {
    order: 2;
    align-self: center;
    border: 0;
    background-color: transparent;
    color: white;
    font-size: 16px;
    text-align: left;
    position: relative;
    z-index: 3;
    display: inline-flex;
    word-break: keep-all;
    align-items: center;
}

.button-cta:hover {
    box-shadow: inset 0px 4px 8px rgba(255, 255, 255, 0.41);
    text-shadow: 0px 2px 3px #e0104e;
}

.button-cta:hover svg {
    filter: drop-shadow(0px 2px 3px #e0104e);
}

.button-wrapper:hover::after {
    opacity: 1;
}
</style>
